
import { Component, Vue, Prop } from 'vue-property-decorator'
import ImageSlider from '@/components/explore/ImageSlider.vue'
import QrcodeVue from 'qrcode.vue'
import { IShowcasePage } from '@/types/showcase'
@Component({
  components: {
    ImageSlider,
    QrcodeVue
  }
})
export default class FundingResult extends Vue {
  @Prop({ required: true }) showcasePage: IShowcasePage

  qrCodeHref = "https://www.google.com/"

  get fakeVars () {
    return {
      text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet. Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.",
      projectListTitle: "Wir empfehlen diese Projekte"
    }
  }
}
